const statusEnum = [
  { value: 0, label: "AGUARDANDO", ENUM: "WAITING" },
  { value: 1, label: "CONCLUÍDA", ENUM: "CONCLUDED" },
  { value: 2, label: "CANCELADO", ENUM: "CANCELED" },
  { value: 3, label: "FALHA", ENUM: "FAILED" },
  { value: 4, label: "PENDENTE", ENUM: "PENDING" },
  { value: 5, label: "PROCESSANDO", ENUM: "PROCESSING" },
];

export default statusEnum;
